import { render, staticRenderFns } from "./TeamResultItem.vue?vue&type=template&id=72ba535c&scoped=true"
import script from "./TeamResultItem.vue?vue&type=script&lang=js"
export * from "./TeamResultItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ba535c",
  null
  
)

export default component.exports